import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { InvoiceItemModel } from '../models/invoice.item';
import { InvoiceModel }     from '../models/invoice';
import { MessagesService }  from '../../messages/messages.service';

@Component({
  template: require('./invoice.custom-markup.component.html')
})
export class InvoiceCustomMarkupComponent implements OnInit {
  @Input() invoice : InvoiceModel;
  @Input() item    : InvoiceItemModel;
  @Input() product : any;

  confirming   = false;
  cost         : number;
  markup       = 0;
  markupAmount = 0;
  newRetail    : number;
  unitPrice    : number;

  constructor (
    public  activeModal      : NgbActiveModal,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    this.cost      = this.invoice.price_includes_tax ? Number(this.product.cost_including_tax) : Number(this.product.cost);
    this.unitPrice = Number(this.item.unit_price);
    this.newRetail = this.unitPrice;
  }

  calculateAmount () : void {
    if (this.markup == null) {
      this.markupAmount = null;
      this.newRetail    = null;
      return;
    }
    this.markupAmount = parseFloat((this.unitPrice * this.markup / 100).toFixed(2));
    this.newRetail    = parseFloat((this.unitPrice + this.markupAmount).toFixed(2));
  }

  calculateMarkup () : void {
    if (this.markupAmount == null || this.unitPrice <= 0) {
      this.markup    = null;
      this.newRetail = null;
      return;
    }
    this.markup    = parseFloat((this.markupAmount / this.unitPrice * 100).toFixed(2));
    this.newRetail = parseFloat((this.unitPrice + this.markupAmount).toFixed(2));
  }

  cancelConfirm () : void {
    this.confirming = false;
  }

  confirm () : void {
    this.activeModal.close(this.newRetail);
  }

  save () : void {
    if (this.newRetail == null || this.newRetail < this.unitPrice) {
      this.messagesService.error(this.translateService.instant('JS_SPACE.MESSAGES.MARKUP_PRICE_BELOW_UNIT_PRICE'));
      return;
    }

    this.confirming = true;
  }
}
